

import axiosInstance from "../../../common/axiosInstance";


/*
 * =========================================
 * GET PROJECT MANAGERS
 * =========================================
 */
export const getProjectManagers = async () => {
  try {
    console.log(
      "========== GET PROJECT MANAGERS =========="
    );

    const response = await axiosInstance.get(
      "/employees/managers"
    );

    console.log(
      "PROJECT MANAGERS RESPONSE:",
      response.data
    );

    return response.data;
  } catch (error) {
    console.error(
      "========== GET PROJECT MANAGERS ERROR =========="
    );

    console.error(
      "STATUS:",
      error.response?.status
    );

    console.error(
      "RESPONSE:",
      error.response?.data
    );

    console.error(
      "MESSAGE:",
      error.response?.data?.message
    );

    console.error(
      "VALIDATION ERRORS:",
      error.response?.data?.errors
    );

    throw error;
  }
};


/*
 * =========================================
 * GET PROJECTS
 * =========================================
 */
export const getProjects = async () => {
  try {
    console.log(
      "========== GET PROJECTS =========="
    );

    const response =
      await axiosInstance.get(
        "/projects"
      );

    console.log(
      "PROJECTS RESPONSE:",
      response.data
    );

    return response.data;
  } catch (error) {
    console.error(
      "========== GET PROJECTS ERROR =========="
    );

    console.error(
      "STATUS:",
      error.response?.status
    );

    console.error(
      "RESPONSE:",
      error.response?.data
    );

    console.error(
      "MESSAGE:",
      error.response?.data?.message
    );

    throw error;
  }
};


/*
 * =========================================
 * CREATE PROJECT
 * =========================================
 */
export const createProject = async (
  projectData
) => {
  try {
    console.log(
      "========== CREATE PROJECT =========="
    );

    console.log(
      "REQUEST URL:",
      "/projects"
    );

    console.log(
      "REQUEST BODY:",
      projectData
    );

    const response =
      await axiosInstance.post(
        "/projects",
        projectData
      );

    console.log(
      "CREATE PROJECT RESPONSE:",
      response.data
    );

    return response.data;
  } catch (error) {
    console.error(
      "========== CREATE PROJECT ERROR =========="
    );

    console.error(
      "STATUS:",
      error.response?.status
    );

    console.error(
      "RESPONSE:",
      error.response?.data
    );

    console.error(
      "MESSAGE:",
      error.response?.data?.message
    );

    console.error(
      "VALIDATION ERRORS:",
      error.response?.data?.errors
    );

    throw error;
  }
};


/*
 * =========================================
 * GET PROJECT BY UUID
 * =========================================
 */
export const getProjectByUuid = async (
  projectUuid
) => {
  try {
    console.log(
      "========== GET PROJECT BY UUID =========="
    );

    console.log(
      "PROJECT UUID:",
      projectUuid
    );

    const response =
      await axiosInstance.get(
        `/project/${projectUuid}`
      );

    console.log(
      "PROJECT DETAILS RESPONSE:",
      response.data
    );

    return response.data;
  } catch (error) {
    console.error(
      "========== GET PROJECT BY UUID ERROR =========="
    );

    console.error(
      "STATUS:",
      error.response?.status
    );

    console.error(
      "RESPONSE:",
      error.response?.data
    );

    console.error(
      "MESSAGE:",
      error.response?.data?.message
    );

    throw error;
  }


};

export const getOrganizations = async () => {
  try {
    console.log(
      "========== GET ORGANIZATIONS =========="
    );

    const response = await axiosInstance.get(
      "/organizations"
    );

    console.log(
      "ORGANIZATIONS RESPONSE:",
      response.data
    );

    return response.data;

  } catch (error) {

    console.error(
      "========== GET ORGANIZATIONS ERROR =========="
    );

    console.error(
      "STATUS:",
      error.response?.status
    );

    console.error(
      "RESPONSE:",
      error.response?.data
    );

    console.error(
      "MESSAGE:",
      error.response?.data?.message
    );

    throw error;
  }
};